export const SAVING_PLAN_ITEMS = [
  {
    title: 'Age',
    description: 'Younger drivers tend to pay higher premiums as they’re more likely to be involved in accidents.',
    productPageUrl: null
  },
  {
    title: 'Driving record and claims history',
    description: 'If you haven’t made an at-fault claim on your policy for a long time (or ever), you could save on your premium. The same goes for low-kilometre drivers.',
    productPageUrl: null
  },
  {
    title: 'Your car',
    description: 'Premiums vary depending on the type, make and model of your car.',
    productPageUrl: null
  },
  {
    title: 'Where you live and park',
    description: 'Your address and where you normally park your car can impact the cost of your premium. There’s a difference between parking in a garage and parking on the street, due to the risk of damage and theft happening to your car.',
    productPageUrl: null
  },
  {
    title: 'Excess',
    description: 'The higher your excess, the lower your premium will be.',
    productPageUrl: null
  }
]

export const INFO_BLOCKS = [
  {
    title: '<strong>What is</strong> comprehensive car insurance?',
    description: `
      <p>
        Comprehensive car insurance covers your vehicle in the event of accidents, theft, fire and weather damage, as well as damage to other vehicles and property.
      </p>

      <p>
        Comprehensive car insurance is different from other options in the market, including third party car insurance. Third party car insurance generally covers damage you cause to other people’s cars and property.
      </p>

      <p>
        However, this premium difference can provide peace of mind as it may reduce the likelihood of out of pocket expenses if you’re on the most extensive level of cover, which is comprehensive car insurance.
      </p>
    `,
    icon: '/icons/car-insurance/search.svg',
    iconDimensions: {
      width: 113,
      height: 113
    }
  },
  {
    title: '<strong>Do I need</strong> comprehensive car insurance?',
    description: `
      <p>
        Good question!
      </p>

      <p>
        As a general rule of thumb, it’s probably a good idea to consider comprehensive cover if you’ve got room in your budget, as this may save you headaches down the line having the most comprehensive cover available
      </p>

      <p>
        If you decide to take out a car loan, the lender might require you to take out comprehensive car insurance as part of the contract you sign. This will vary depending on your lender..
      </p>
    `,
    icon: '/icons/car-insurance/notes.svg',
    iconDimensions: {
      width: 113,
      height: 113
    }
  }
]

export const AT_A_GLANCE_ITEMS = [
  {
    description: 'Covers your car in the event of accidents, theft, fire and weather damage.',
    icon: '/icons/car-insurance/accident-cover.svg',
    iconDimensions: {
      width: 56,
      height: 56
    }
  },
  {
    description: 'Generally the most extensive type of car insurance available.',
    icon: '/icons/car-insurance/extensive-cover.svg',
    iconDimensions: {
      width: 56,
      height: 56
    }
  },
  {
    description: 'Covers damage to third-party vehicles and property caused by your car.',
    icon: '/icons/car-insurance/third-party-cover.svg',
    iconDimensions: {
      width: 56,
      height: 56
    }
  },
  {
    description: 'Optional extras can include hire car cover, windscreen damage cover and more.',
    icon: '/icons/car-insurance/optional-cover.svg',
    iconDimensions: {
      width: 56,
      height: 56
    }
  }
]

export const GREAT_DEAL_ITEMS = [
  {
    title: 'Better value for money',
    description: 'Working within a budget? We’ll help you find the policy that makes your money go further.',
    icon: '/icons/car-insurance/better-value.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  },
  {
    title: 'Add-ons you’ll actually use',
    description: 'Looking for a hire car? Want nil excess for repairs or replacement of your windscreen? Our panel of insurers can help you with what you’re after.',
    icon: '/icons/car-insurance/add-ons.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  },
  {
    title: 'Compare insurers side by side',
    description: 'Car insurance shouldn’t be complicated, confusing or full of jargon. Compare Club allows you to select from our panel of insurers the cover that meets your needs.',
    icon: '/icons/car-insurance/compare-side-by-side.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  }
]

export const INFO_TABLE = [
  {
    title: '<strong>Included as standard</strong>',
    titleClass: 'bg-semantic-surface-container-high',
    listIcon: {
      component: 'IconsCheckUnderline',
      props: {
        underline: false
      }
    },
    list: [
      'Accident and collision damage to your vehicle and third-party vehicles',
      'Theft and vandalism to your vehicle',
      'Legal liability for damage or loss to third party property.',
      'Fire, hail, storm, flood and weather-related damage to your vehicle',
      'Towing',
      'New car replacement (if the car is a write-off)[1]',
      'Emergency transport & accommodation cover'
    ]
  },
  {
    title: '<strong>Optional extras</strong>',
    titleClass: 'bg-blue-20',
    listIcon: {
      component: 'IconsCheckUnderline'
    },
    list: [
      'No excess or reduced excess on windscreen damage.',
      'Limited Hire car costs following an accident',
      'Limited Hire car cost following theft (most insurers include this as standard cover)',
      'Additional personal effects cover',
      'Roadside assistance',
      'Some insurers automatically include cover for new car if purchase brand new from a dealer within last 24 months.'
    ]
  }
]
